/**
 * Remove valores sensíveis (token, authorization, etc.) de objetos antes de exibir no chat.
 * Garante que tokens e credenciais jamais apareçam na tela.
 */
const SENSITIVE_KEYS = [
  'token',
  'authorization',
  'bearer',
  'access_token',
  'accessToken',
  'api_key',
  'apikey',
  'apiKey',
  'password',
  'secret',
  'auth',
  'cookie',
  'x-api-key',
  'refresh_token',
  'refreshToken',
];

const REDACTED = '[oculto]';

function isSensitiveKey(key: string): boolean {
  const lower = key.toLowerCase().replace(/_/g, '').replace(/-/g, '');
  return SENSITIVE_KEYS.some((s) => lower.includes(s.toLowerCase().replace(/_/g, '')));
}

/**
 * Retorna uma cópia do objeto com valores sensíveis substituídos por [oculto].
 * Usado ao exibir Request/Response no detalhe de execução no chat.
 */
export function sanitizeForDisplay(value: unknown): unknown {
  if (value === null || value === undefined) {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map(sanitizeForDisplay);
  }
  if (typeof value === 'object' && value !== null) {
    const out: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(value)) {
      out[k] = isSensitiveKey(k) ? REDACTED : sanitizeForDisplay(v);
    }
    return out;
  }
  return value;
}

/** Serializa para exibição de forma segura (evita quebrar o UI por referência circular ou erro). */
export function safeStringify(value: unknown, indent = 2): string {
  try {
    const sanitized = sanitizeForDisplay(value);
    return JSON.stringify(sanitized, null, indent);
  } catch {
    return typeof value === 'string' ? value : '[Não foi possível exibir]';
  }
}
